import { WireComponentKind } from "../wire/component-kind";
import type { WireComponent } from "../wire/types";
import type { WireContainerComponent, WireFormContainerComponent } from "./fluent-components-containers";

type WireAnyContainerComponent = WireContainerComponent | WireFormContainerComponent;

// ##isWireContainerComponent:
// This needs to be kept in sync with `WireAnyContainerComponent` above.
export function isWireContainerComponent(component: WireComponent): component is WireAnyContainerComponent {
    const { kind } = component;
    return kind === WireComponentKind.Container || kind === WireComponentKind.FormContainer;
}
